(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anitials-pack-benefits"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ani-pack-benefits')) return;
  class PackBenefits extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-single');
      this.pack = this.scope?.querySelector('[data-pack-lab]');
      if (!this.pack) return;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'es', {style: 'currency', currency: this.dataset.currency || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2});
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.pack, {attributes: true, attributeFilter: ['data-pack-cart-total', 'data-pack-price', 'data-pack-ready']});
      this.placementObserver = new MutationObserver(this.schedule);
      this.placementObserver.observe(this.scope, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-purchase-amount']});
      this.addEventListener('click', this.openDetails);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.placementObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.removeEventListener('click', this.openDetails);
    }
    openDetails(event) {
      const link = event.target.closest('a[href^="#ani-initial-"]');
      if (!link) return;
      const details = document.getElementById(link.hash.slice(1));
      if (!details) return;
      event.preventDefault();
      if (details.tagName === 'DETAILS') details.open = true;
      details.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    }
    update() {
      const threshold = Number(this.dataset.threshold) || 0;
      const cartTotal = Math.max(0, Number(this.pack.dataset.packCartTotal ?? this.dataset.cartTotal) || 0);
      const message = this.querySelector('[data-pack-shipping-message]');
      const progress = this.querySelector('progress');
      if (message && progress) {
        const remaining = Math.max(0, threshold - cartTotal);
        const amount = this.money.format(remaining / 100);
        const text = remaining ? this.dataset.remaining.replace('__amount__', amount) : this.dataset.free;
        message.classList.toggle('ani-initial-shipping-free', remaining === 0);
        if (message.textContent !== text || (remaining > 0 && !message.querySelector('strong'))) {
          if (remaining) {
            const [before, after = ''] = this.dataset.remaining.split('__amount__');
            const strong = document.createElement('strong');
            strong.textContent = amount;
            message.replaceChildren(document.createTextNode(before), strong, document.createTextNode(after));
          } else message.textContent = text;
        }
        progress.value = Math.min(threshold, cartTotal);
      }
      const ready = this.pack.dataset.packReady === 'true';
      const price = Number(this.pack.dataset.packPrice) || 0;
      const placement = this.scope.querySelector('klarna-placement');
      if (!ready || price <= 0 || !placement) return;
      if (placement.dataset.purchaseAmount !== String(price) || this.lastPrice !== price || this.lastPlacement !== placement) {
        placement.dataset.purchaseAmount = String(price);
        this.lastPrice = price;
        this.lastPlacement = placement;
        if (window.KOSMApp?.updatePurchaseAmount) window.KOSMApp.updatePurchaseAmount(price);
        else if (window.Klarna?.OnsiteMessaging?.refresh) window.Klarna.OnsiteMessaging.refresh();
      }
    }
  }
  customElements.define('ani-pack-benefits', PackBenefits);
})();
  } catch(e) { console.error(e); }
})();

})();
